<template>
  <layout name="LayoutDefault">
    <div class="About">
      <div class="container">
        <!-- Page Features -->
        <div class="contents min-height">
          <div class="row">
            <div class="col-lg-12">
              <div v-if="cms && cms.type === 'PDF'">
                <h2 class="mb-4">{{ cms.title }}</h2>
                <div v-if="isPdfLoading" class="pdfLoader"></div>
                <iframe
                  :src="`https://drive.google.com/viewerng/viewer?embedded=true&url=${IMAGEURL}${cms.image}&rm=minimal#toolbar=1`"
                  frameBorder="0"
                  scrolling="auto"
                  width="100%"
                  style="min-height: 70vh"
                  sandbox="allow-scripts allow-same-origin"
                  @load="onLoad"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";

export default {
  name: `Home`,
  data() {
    return {
      cms: null,
      isPdfLoading: true
    };
  },
  components: {
    Layout,
  },
  methods: {
    onLoad() {
      this.isPdfLoading = false;
    },
    async getCMS() {
      const response = await this.$http.get(`cms/${this.$route.params.id}`);
      if (response.data.status) {
        this.cms = response.data.data;
        //console.log(this.cms);
      }
    },
  },
  mounted() {
    this.getCMS();
  },
};
</script>
<style>
.pdfLoader {
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
  margin: auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
